import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { Pane } from 'components/shared/Pane/Pane'
import { useOverviewCareer } from './hooks'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { OverviewTable } from './common/OverviewTable'
import { JobSeekerModal } from 'components/modals/AddJobSeekerModal/AddJobSeekerModal'

import styles from './Overview.module.scss'
import { PlusCircleIcon } from 'components/shared/Icon/model'
import { DeleteJobSeekerModal } from 'components/modals/DeleteJobSeekerModal/DeleteJobSeekerModal'

export const Overview = () => {
  const { state, handlers } = useOverviewCareer()
  const {
    candidate,
    search,
    isOverviewModalOpen,
    isDeleteJobSeekerOpen,
  } = state

  const {
    setSearch,
    handleOverviewModalOpen,
    handleOverviewModalClose,
    handleOverviewModalConfirm,
    handleDeleteJobSeekerClose,
    handleDeleteJobSeekerConfirm,
    handleCopy,
    handleDelete,
    handleEdit,
  } = handlers

  return (
    <>
      <Pane.Header className={styles.header}>
        <SearchWidget query={search} onChange={setSearch} />
        <Box>
          <Button
            className={styles.button}
            color="primary"
            icon={PlusCircleIcon}
            label={t`Add person`}
            size="small"
            variant="filled"
            onClick={handleOverviewModalOpen}
          />
        </Box>
      </Pane.Header>
      <OverviewTable
        search={search}
        handleCopy={handleCopy}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      <JobSeekerModal
        onCancel={handleOverviewModalClose}
        onClose={handleOverviewModalClose}
        onConfirm={handleOverviewModalConfirm}
        isOpen={isOverviewModalOpen}
        {...{ candidate }}
      />
      <DeleteJobSeekerModal
        onCancel={handleDeleteJobSeekerClose}
        onClose={handleDeleteJobSeekerClose}
        onConfirm={handleDeleteJobSeekerConfirm}
        isOpen={isDeleteJobSeekerOpen}
      />
    </>
  )
}
